"use client";

import React from "react";

const WhyChooseSealant: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Why Choose Sealant Over Other Treatments?
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        When it comes to protecting your teeth from decay, you might be wondering
        why dental sealants are preferable to other treatments like fillings or
        root canal therapy. The answer lies in their preventive nature and the fact
        that they can often reverse early signs of decay.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Fillings, on the other hand, are used to repair teeth after a cavity has
        already formed. While effective at stopping further decay, fillings require
        drilling into the tooth and removing damaged enamel – a process that
        weakens the overall structure of the tooth. In contrast, dental sealants
        protect your teeth before any damage occurs, preserving their natural
        strength.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Root canal therapy is another treatment option for severe cases of tooth
        decay. However, this procedure involves removing the pulp (the inner
        tissue) from the tooth and filling the resulting space with a synthetic
        material called gutta-percha. Although root canals can save teeth that
        would otherwise need to be extracted, they are much more invasive than
        dental sealants and should only be considered when other treatments have
        failed.
      </p>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        In summary, dental sealants offer several advantages over other treatment
        options:
      </p>
      <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg">
        {[
          <span key="1">
            They prevent decay before it starts, preserving the natural strength of
            your teeth.
          </span>,
          <span key="2">
            Sealants can often reverse early signs of decay by allowing your saliva
            to remineralize the enamel.
          </span>,
          <span key="3">
            Dental sealants are less invasive than fillings and root canals,
            requiring no drilling or removal of tooth material.
          </span>,
        ].map((item, idx) => (
          <li
            key={idx}
            className="group hover:bg-gray-50 transition-all duration-300 rounded-md py-1"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default WhyChooseSealant;